export const OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_SUCCESS =
  'OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_SUCCESS';
export const OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_FAILURE =
  'OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_FAILURE';

export const OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_SUCCESS =
  'OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_SUCCESS';
export const OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_FAILURE =
  'OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_FAILURE';

export const OVERNIGHT_CAMP_GET_REOPEN_SUCCESS =
  'OVERNIGHT_CAMP_GET_REOPEN_SUCCESS';
export const OVERNIGHT_CAMP_GET_REOPEN_FAILURE =
  'OVERNIGHT_CAMP_GET_REOPEN_FAILURE';
